import { jsx as _jsx } from "react/jsx-runtime";
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import { SuggestionRightAccessory } from '#pplx/frontend/apps/ask/suggest-dropdown/primitives/components/SuggestionRightAccessory.js';
import { getDisplayedSuggestionDescription, getSuggestionDisplayText, runSuggestionAction, } from '#pplx/frontend/apps/ask/suggest-dropdown/primitives/utils/utils.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { createAutosuggestPlugin } from '#pplx/frontend/composer-sdk-plugins/autosuggest/createAutosuggestPlugin.js';
import classNames from 'classnames';
function toTypeaheadItems({ suggestions, highlightQuery, getRowIcon, onFill, }) {
    if (suggestions.length === 0)
        return EMPTY_ARRAY;
    return suggestions.map((suggestion, position) => {
        const { icon, image } = getRowIcon(suggestion, highlightQuery);
        return {
            id: `${suggestion.query_uuid ?? suggestion.identifier ?? suggestion.query}-${position}`,
            label: getSuggestionDisplayText({
                ...suggestion,
                description: getDisplayedSuggestionDescription(suggestion),
                query: suggestion.query_preview ?? suggestion.query,
            }),
            icon: image ? { type: 'image', url: image } : { type: 'icon', icon },
            iconTone: 'quiet',
            trailingAccessory: ({ highlighted }) => suggestion.shortcut ?? (_jsx(TextPrimitive, { as: "span", color: "super", variant: "smallBold", className: classNames('flex items-center', !highlighted && !suggestion.url && 'opacity-0'), children: _jsx(SuggestionRightAccessory, { category: suggestion.category, url: suggestion.url, onClick: () => onFill(suggestion.submission_query ?? suggestion.query_preview ?? suggestion.query, suggestion.url) }) })),
            highlightQuery,
            payload: { position, suggestion },
        };
    });
}
/** Retains Ask row labels and selection policy when supplying the shared autosuggest dropdown. */
export function createAskAutosuggestPlugin({ enabled = true, debounce, activateOnEmptyQuery, getRowIcon, getPendingSuggestions, getSuggestions, isQueryEligible, onSelect, onFill, onSuggestionsView, }) {
    return createAutosuggestPlugin({
        id: 'ask-composer-autosuggest',
        enabled,
        debounce,
        activateOnEmptyQuery,
        initialSelection: 'none',
        matchQuery: isQueryEligible,
        getPendingItems: (query) => toTypeaheadItems({
            suggestions: getPendingSuggestions(query),
            highlightQuery: query,
            getRowIcon,
            onFill,
        }),
        getResults: async (query, abortSignal) => {
            const suggestions = await getSuggestions({ query, abortSignal });
            onSuggestionsView(suggestions);
            return toTypeaheadItems({ suggestions, highlightQuery: query, getRowIcon, onFill });
        },
        onSelect: (item, _editor, { selectionMethod }) => {
            const { position, suggestion } = item.payload;
            switch (selectionMethod) {
                case 'pointer':
                    runSuggestionAction(suggestion.actionHandler, () => onSelect(suggestion, position));
                    break;
                case 'keyboard':
                    onSelect(suggestion, position);
                    break;
                default:
                    assertUnreachableValue(selectionMethod);
            }
        },
    });
}
//# sourceMappingURL=createAskAutosuggestPlugin.js.map